import i18n from 'i18next';
import I18NextVue from 'i18next-vue';
import LanguageDetector from 'i18next-browser-languagedetector';
import {Settings} from 'luxon';
import {App} from 'vue';

export const createI18n = (app: App, locales: any) => {
  i18n.on('languageChanged', (locale) => {
    Settings.defaultLocale = locale;
  });
  
  i18n
    .use(new LanguageDetector(null, {lookupLocalStorage: 'LOCALE_SWITCHER_LANGUAGE'}))
    // init i18next
    // https://www.i18next.com/overview/configuration-options
    .init({
      resources: locales,
      fallbackLng: 'en',
      debug: false,
      interpolation: {
        escapeValue: false,
      },
    });

  return I18NextVue(app, {i18next: i18n});
};